import type { ActionOptionRedirect } from '@repo/common';

import { ActionType, Step } from '@repo/common';

import { VerificationSuccess as VerificationSuccessResult } from '@/components/verification-result/verification-success';
import { withStep } from '@/hoc/with-step';
import { useCountdown } from '@/hooks/use-countdown';
import { useResolveVerification } from '@/hooks/use-resolve-verification';
import * as GSC from '@/styles/GlobalStyles';
import { msToSec } from '@/utils/time';
import { getStepAction } from '@/utils/workflow';

export const VerificationSuccess = withStep({ only: [Step.SUCCESS] })(({ step }) => {
  const redirectAction = getStepAction(step, { exact: ActionType.REDIRECT }) as ActionOptionRedirect | undefined;
  const url = redirectAction?.data.url;
  const payload = redirectAction?.data.payload;
  const redirectTimeout = redirectAction?.data.redirectTimeout;
  const autoRedirectEnabled = !!redirectAction && !!redirectTimeout;
  const resolveSuccessVerification = useResolveVerification({ url: url!, payload: payload! });

  useCountdown({
    onFinish: resolveSuccessVerification,
    enabled: autoRedirectEnabled,
    seconds: msToSec(redirectTimeout ?? 0),
  });

  return (
    <GSC.FadeInContainer>
      <VerificationSuccessResult />
    </GSC.FadeInContainer>
  );
});
